export default (client) => {
  return {
    salesSubmit({
      name,
      email,
      country,
      team,
      companySize,
      companyName,
      role,
      phoneNumber,
      message,
    }) {
      return client.post('/saas/contact/sales-submit/', {
        name,
        email,
        country,
        team,
        company_size: companySize,
        company_name: companyName,
        role,
        phone_number: phoneNumber,
        message,
      })
    },
    partnerSubmit({
      name,
      email,
      country,
      type,
      companySize,
      companyName,
      role,
      phoneNumber,
      message,
    }) {
      return client.post('/saas/contact/partner-submit/', {
        name,
        email,
        country,
        type,
        company_size: companySize,
        company_name: companyName,
        role,
        phone_number: phoneNumber,
        message,
      })
    },
  }
}
